import React from 'react';
import { RotateCcw, XCircle, CheckCircle2, ChevronRight } from 'lucide-react';

// QC-CORR-MODAL-001 — compact persistent reminder shown in Fulfillment instead
// of the former full-height correction card. "View Details" reopens the modal.
export default function CorrectionReminderBar({ data, isReturn, onViewDetails }) {
  const isAcked = !!data?.qc_feedback_acknowledged_at;
  const tone = isReturn
    ? 'bg-amber-50 border-amber-200 text-amber-900'
    : 'bg-red-50 border-red-200 text-red-900';
  const Icon = isReturn ? RotateCcw : XCircle;
  return (
    <div className={`qc-corr-reminder flex items-center gap-2 flex-wrap rounded-lg border px-3 py-1.5 text-sm ${tone}`}
      data-testid="processor-feedback-banner" data-acknowledged={isAcked ? 'true' : 'false'}>
      <Icon className="w-4 h-4 flex-shrink-0" />
      <span className="font-semibold">{isReturn ? 'Correction Required' : 'Rejected — Revisions Required'}</span>
      <span className="opacity-50">·</span>
      <span>Iteration {data?.qc_iteration || 1} of QC</span>
      <span className="opacity-50">·</span>
      {isAcked ? (
        <span className="inline-flex items-center gap-1 text-emerald-700 font-medium" data-testid="correction-reminder-acked">
          <CheckCircle2 className="w-3.5 h-3.5" /> Acknowledged
        </span>
      ) : (
        <span className="inline-flex items-center gap-1 font-medium" data-testid="correction-reminder-unacked">
          <span className="w-2 h-2 rounded-full bg-current animate-pulse" /> Acknowledgement required
        </span>
      )}
      <span className="opacity-50">·</span>
      <button type="button" onClick={onViewDetails}
        className="inline-flex items-center gap-0.5 font-semibold underline underline-offset-2 hover:opacity-80"
        data-testid="correction-reminder-view-details">
        {isAcked ? 'View Details' : 'Review'} <ChevronRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
